import App from './component'

export default App
